import { PureComponent } from 'react';
import { connect } from 'react-redux';

import RewardsPointsForProductQuery from 'Query/RewardsPointsForProduct.query';
import { fetchQuery } from 'Util/Request';

import RewardsPointsForProduct from './RewardsPointsForProduct.component';

/** @namespace Pwa/Component/RewardsPointsForProduct/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isSignedIn: state.MyAccountReducer.isSignedIn,
    product: state.ProductReducer.product,
});

/** @namespace Pwa/Component/RewardsPointsForProduct/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/RewardsPointsForProduct/Container */
export class RewardsPointsForProductContainer extends PureComponent {
    state = {
        productRewardPoints: null,
    };

    componentDidMount() {
        const { isSignedIn } = this.props;

        if (isSignedIn) this.getProductRewardPoints();
    }

    componentDidUpdate() {
        const { isSignedIn } = this.props;

        if (isSignedIn) this.getProductRewardPoints();
    }

    containerProps() {
        const { product, isSignedIn } = this.props;

        return {
            product,
            isSignedIn,
            ...this.state,
        };
    }

    getProductRewardPoints() {
        const { productId } = this.props;
        fetchQuery(RewardsPointsForProductQuery.getRewardsPointsForProduct(productId)).then(
            /** @namespace Pwa/Component/RewardsPointsForProduct/Container/RewardsPointsForProductContainer/getProductRewardPoints/fetchQuery/then */
            ({ mstRewardsPointsForProduct: { points } }) => {
                this.setState({ productRewardPoints: points });
            }
        );
    }

    render() {
        return <RewardsPointsForProduct {...this.containerFunctions} {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RewardsPointsForProductContainer);
